/* global WebSocket */ import { verifyEvent } from "./pure.js";
import { AbstractSimplePool } from "./abstract-pool.js";
var _WebSocket;
try {
  _WebSocket = WebSocket;
} catch  {}
export function useWebSocketImplementation(websocketImplementation) {
  _WebSocket = websocketImplementation;
}
export class SimplePool extends AbstractSimplePool {
  constructor(options){
    super({
      verifyEvent,
      websocketImplementation: _WebSocket,
      maxWaitForConnection: 3000,
      ...options
    });
  }
}
export * from "./abstract-pool.js";
//# sourceMappingURL=pool.js.map